import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import { ENABLE_FX_SIMPLE_PREORDER } from '~/app/settings';
import FXPreorderLayout from '~/app/layouts/FXPreorderLayout';
import loadable from '@loadable/component';

// AE-specific preorder components
const FXSimplePreorderPageAE = loadable(() => import(/* webpackChunkName: "FXSimplePreorderPageAE" */ '~/app/pages/ae/FXSimplePreorderPage'));

const AEReserveRouter = () => (
  <Switch>
    {/* FX Simple Preorder - AE (handles both Arabic and English) */}
    {ENABLE_FX_SIMPLE_PREORDER && (
      <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER}`} >
        <FXPreorderLayout>
          <FXSimplePreorderPageAE modelCode='FX Super One' />
        </FXPreorderLayout>
      </Route>
    )}

    <Redirect to="/:locale(ae_ar|ae_en)/404" />
  </Switch>
);

export default AEReserveRouter;
